
/**
 * 
 */

import React from 'react';
import DmLogo from './DmLogo.svg';

import StateMachine from 'react-simple-state/dist';
const appState = new StateMachine();



class TopNav extends React.Component {

  constructor( props ) {
    super( props );
    
    this.handleLogoClick = this.handleLogoClick.bind( this );
  }

  handleLogoClick(){
    let currentMode = appState.getState( 'app-main-mode' );
    console.log( "App mode: " + currentMode.appMainMode );

    if( typeof this.props.onLogoClick !== 'undefined' ){
      this.props.onLogoClick();
    }
    
    // alert( "V2 - " +  window.debugNumber1 + " / " + window.debugNumber2 );

    return false;
  }


  render() {
    let showLanguageLinks = true;

    if( typeof this.props.showLanguageLinks !== 'undefined' ){
      showLanguageLinks = this.props.showLanguageLinks;
    }

    // languages list: Object.keys(i18n.services.resourceStore.data)

    return (
      <div className="app-fragment top-nav grid-cols-2 grid grid-flow-row gap-4">
        <div className="logo" title="v2022-08-18-1">
          <span onClick={(e) => this.handleLogoClick()} >
            <img src={DmLogo} alt="Documental"/>
          </span>
        </div>
        <div>
          
          {( showLanguageLinks ) && (
            <a href="#/"></a>
          )}

        </div>
      </div>
    );
  }

}

export default TopNav;
